import { render, staticRenderFns } from "./BillingV2Page.vue?vue&type=template&id=45c879ff"
import script from "./BillingV2Page.vue?vue&type=script&lang=ts"
export * from "./BillingV2Page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {V2PlanCardSkeleton: require('/app/components/Billing/V2/V2PlanCardSkeleton.vue').default,ZAlert: require('/app/components/zeal/ZAlert/ZAlert.vue').default,V2ActiveEnterprisePlanCard: require('/app/components/Billing/V2/V2ActiveEnterprisePlanCard.vue').default,V2ActivePlanCard: require('/app/components/Billing/V2/V2ActivePlanCard.vue').default,V2EnterprisePlanCard: require('/app/components/Billing/V2/V2EnterprisePlanCard.vue').default,V2CurrentPlanCard: require('/app/components/Billing/V2/V2CurrentPlanCard.vue').default,V2UpgradePlanCard: require('/app/components/Billing/V2/V2UpgradePlanCard.vue').default,V2PaymentMethods: require('/app/components/Billing/V2/V2PaymentMethods.vue').default,V2AddCreditModal: require('/app/components/Billing/V2/V2AddCreditModal.vue').default,V2DeleteCardModal: require('/app/components/Billing/V2/V2DeleteCardModal.vue').default,V2CancelSubscriptionModal: require('/app/components/Billing/V2/V2CancelSubscriptionModal.vue').default,V2BillingInfo: require('/app/components/Billing/V2/V2BillingInfo.vue').default,V2RecentInvoices: require('/app/components/Billing/V2/V2RecentInvoices.vue').default})
